<template>
  <div>
    <web-header :searchStatus="$route.query.moduleId"></web-header>
    <Breadcrumb crumbTitle="志愿者协会" crumbName="ORGANIZATION" location="志愿者协会 > 协会列表"></Breadcrumb>

    <div class="app-volunteer">
      <div class="volunteer-box">
        <div class="volunteer-top">
          <i>协会属地</i>
          <ul>
            <li
              v-for="(item,index) in liData"
              :key="index"
              :class="{active:liStyle==item.id}"
              @click="getStyle(item.id)"
            >{{item.name}}</li>
          </ul>
        </div>
      </div>
      <WtDataList
        v-model="news.list"
        :url="$url.news.list"
        :pageSize="12"
        :search="search"
        :isPage="true"
         ref="newsList"
      >
        <div class="porject-box" slot="list">
          <ul>
            <li v-for="(item,index) in news.list" :key="index">
              <router-link :to="{ name: 'organizationInfo',query: { id: item.id}}" target="_blank">
                <div class="act-top">
                  <img :src="item.cover_photo_text[0].path" v-if="item.cover_photo" />
                </div>
                <div class="act-bottom">
                  <p>{{item.title}}</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </WtDataList>
    </div>
  </div>
</template>
<script>
import webHeader from "../Public/header";
import Breadcrumb from "../Public/breadcrumb";
export default {
  components: {
    webHeader,
    Breadcrumb
  },
  data() {
    return {
      search: {
        if_show: 1, //前台展示
        type: 5
      },
      news: {},
      liData: [
        {
          id: 0,
          name: "全部"
        }
      ],
      
      liStyle: 0,
      numStyle: 1
    };
  },
  methods: {
    getStyle(id) {
      this.liStyle = id;
      this.search.province = id;
      this.$refs.newsList.handleSearch();
    },
    getNum(id) {
      this.numStyle = id;
    }
  },
  created() {
    //查询所有的志愿者协会地区
    this.$db.post(this.$url.news.association).then(resp => {
      var liData = this.liData.concat(resp.data);
      this.liData = liData;
    });
  }
};
</script>


<style lang="scss" scoped>
#app-volunteer {
  width: 100%;
}
.volunteer-box {
  max-width: 1300px;
  margin: 50px auto;
  .volunteer-top {
    padding-left: 95px;
    position: relative;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    > i {
      font-size: 14px;
      color: #999999;
      font-style: normal;
      position: absolute;
      left: 0;
      top: 6px;
    }
    > ul {
      display: flex;
      flex-wrap: wrap;
      > li {
        list-style: none;
        padding: 6px 15px;
        margin-bottom: 15px;
        margin-right: 10px;
        font-size: 14px;
        color: #999;
        cursor: pointer;
        &.active {
          background-color: #e83a16;
          box-shadow: 0px 2px 19px 0px rgba(214, 0, 15, 0.21);
          border-radius: 16px;
          color: #fff;
        }
      }
    }
  }
}
.porject-box {
  max-width: 1300px;
  margin: 50px auto;
  > ul {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    > li {
      list-style: none;
      width: 400px;
      height: 360px;
      background-color: #ffffff;
      position: relative;
      transition: ease-out 0.6s;
      margin-right: 50px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      cursor: pointer;
      &:hover {
        background-color: #ffffff;
        box-shadow: 0px 6px 19px 0px rgba(11, 2, 5, 0.09);
        > a {
          .act-bottom {
            background-color: #e83a16;
            > span {
              color: #f6b9ad;
            }
            > p {
              color: #fff;
            }
          }
        }
        // border: solid 1px #ededed;
      }
      > a {
        position: relative;
        .act-top {
          width: 100%;
          height: 280px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        .act-bottom {
          padding: 18px 20px;
          transition: linear 0.6s;
          > p {
            font-size: 14px;
            font-weight: normal;
            color: #333;
            line-height: 24px;
            margin-bottom: 6px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > h3 {
            font-size: 18px;
            font-weight: 500;
            color: #333333;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap;
            /* 不换行 */
            text-overflow: ellipsis;
            /* 超出部分省略号显示 */
            margin-bottom: 12px;
          }
          > span {
            font-size: 15px;
            color: #333333;
          }
        }
      }
    }
  }
}
.page-box {
  max-width: 1300px;
  margin: 0 auto;
  margin-bottom: 50px;
  text-align: center;
}
.page-box /deep/ .el-pagination.is-background .btn-prev {
  background-color: #fff;
  border: solid 1px #cccccc;
  border-radius: 50%;
}
.page-box /deep/ .el-pagination.is-background .btn-next {
  background-color: #fff;
  border: solid 1px #cccccc;
  border-radius: 50%;
}
.page-box /deep/ .el-pagination.is-background .el-pager li {
  border-radius: 50%;
  background-color: #fff;
  border: solid 1px #cccccc;
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #e83a16;
  border: solid 1px #e83a16;
}
</style>



// WEBPACK FOOTER //
// src/view/News/organization.vue